import type { EnteredOptionInput } from '@pylot-data/pylotschema'
import {
    GiftCardProductInputArgs,
    GiftProductOptionsValueUid
} from './GiftCardProduct'

//form filed name and uid reference in the query gift_cart_options
//these fields are hardcoded in the BE and not configurable from admin
export enum MapFormToFieldUid {
    'Custom Giftcard Amount' = 'gift_open_amounts',
    'Correo electrónico destinatario' = 'receiver_email',
    'Nombre Destinatario' = 'receiver_name',
    'Confirme Correo electrónico destinatario' = 'receiver_email_confirm',
    'Correo electrónico del remitente' = 'sender_email',
    'Nombre del remitente' = 'sender_name',
    Mensaje = 'gift_message'
}

export type GetMapFieldWithArgs = {
    giftCardOptions: GiftProductOptionsValueUid[]
    formInput: GiftCardProductInputArgs
}

export const getMapFieldWithUid = ({
    giftCardOptions,
    formInput
}: GetMapFieldWithArgs): Array<EnteredOptionInput> => {
    const enteredOptions: EnteredOptionInput[] = []

    giftCardOptions.forEach((option: GiftProductOptionsValueUid) => {
        const value =
            formInput[
                MapFormToFieldUid[
                    option?.title as keyof typeof MapFormToFieldUid
                ]
            ]
        if (value) {
            enteredOptions.push({
                uid: option?.value?.uid,
                value: String(value)
            })
        }
    })

    return enteredOptions
}
